module.exports = __webpack_public_path__ + "static/media/icon_clock.e504e076.svg";